import { foodTypes } from "./foodTypes";

const initialState = {
    biryani : 0,
    biryaniPrice : 0,
    friedRice : 0,
    friedRicePrice : 0,
    vegBiryani : 0,
    vegBiryaniPrice : 0,
    southMeals : 0,
    southMealsPrice : 0,
    northMeals : 0,
    northMealsPrice : 0,
    tandooriChicken : 0,
    tandooriChickenPrice : 0,
    grillChicken : 0,
    grillChickenPrice : 0,
    foodItems : 0
}

export const foodReducer = (state = initialState, {type, payload}) => {
    switch(type) {
        case foodTypes.BIRYANI_INCREASE : {
            return {...state, biryani: state.biryani+1, biryaniPrice:state.biryaniPrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.BIRYANI_DECREASE : {
            return {...state, biryani: state.biryani-1, biryaniPrice:state.biryaniPrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.FRIED_RICE_INCREASE : {
            return {...state, friedRice: state.friedRice+1, friedRicePrice:state.friedRicePrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.FRIED_RICE_DECREASE : {
            return {...state, friedRice: state.friedRice-1, friedRicePrice:state.friedRicePrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.VEG_BIRYANI_INCREASE : {
            return {...state, vegBiryani: state.vegBiryani+1, vegBiryaniPrice:state.vegBiryaniPrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.VEG_BIRYANI_DECREASE : {
            return {...state, vegBiryani: state.vegBiryani-1, vegBiryaniPrice:state.vegBiryaniPrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.SOUTH_MEALS_INCREASE : {
            return {...state, southMeals: state.southMeals+1, southMealsPrice:state.southMealsPrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.SOUTH_MEALS_DECREASE : {
            return {...state, southMeals: state.southMeals-1, southMealsPrice:state.southMealsPrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.NORTH_MEALS_INCREASE : {
            return {...state, northMeals: state.northMeals+1, northMealsPrice:state.northMealsPrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.NORTH_MEALS_DECREASE : {
            return {...state, northMeals: state.northMeals-1, northMealsPrice:state.northMealsPrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.TANDOORI_CHICKEN_INCREASE : {
            return {...state, tandooriChicken: state.tandooriChicken+1, tandooriChickenPrice:state.tandooriChickenPrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.TANDOORI_CHICKEN_DECREASE : {
            return {...state, tandooriChicken: state.tandooriChicken-1, tandooriChickenPrice:state.tandooriChickenPrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.GRILL_CHICKEN_INCREASE : {
            return {...state, grillChicken: state.grillChicken+1, grillChickenPrice:state.grillChickenPrice+payload, foodItems : state.foodItems + 1}
        }
        case foodTypes.GRILL_CHICKEN_DECREASE : {
            return {...state, grillChicken: state.grillChicken-1, grillChickenPrice:state.grillChickenPrice-payload, foodItems : state.foodItems - 1}
        }
        case foodTypes.CLEAR_ALL_FOOD : {
            return initialState
        }
        default : return state
    }
}